/**
 * PKCE (RFC 7636) helpers for the Authorization Code + PKCE flow against
 * Cognito's Hosted UI. Native `window.crypto` only — no dependency. Works
 * over plain `http://localhost` too, since browsers treat localhost as a
 * secure context even without TLS.
 */

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function randomBytes(length: number): Uint8Array {
  return crypto.getRandomValues(new Uint8Array(length));
}

export function generateState(): string {
  return base64UrlEncode(randomBytes(16));
}

export function generateCodeVerifier(): string {
  // 32 random bytes -> 43-character base64url string, within RFC 7636's
  // required 43-128 character range.
  return base64UrlEncode(randomBytes(32));
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  return base64UrlEncode(new Uint8Array(digest));
}
